import React, { Component } from 'react'
import styled from 'styled-components'
import { string } from 'prop-types'
import Slider from 'react-slick'

import { breakpoints, media } from 'styles/media'
import { white } from 'styles/colors'
import { H3, fontWeights } from 'styles/typography'
import { animationTime, animationCurve } from 'styles/global'
import * as spacing from 'styles/spacing'

const Container = styled.div`
  position: relative;
  pointer-events: initial;
  z-index: 10;
  margin-bottom: ${spacing.xxLarge};

  .slick-slide {
    pointer-events: auto; /* Re-emable touch events */
  }

  ${media.small`
    margin-bottom: ${spacing.xxxLarge};
  `};
`

const FlavourContainer = styled.div`
  text-align: center;
  position: relative;
  padding-bottom: 48px;
`

const FlavourFigure = styled.img`
  width: 94px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${spacing.large};
  transform: scale(0.66);
  opacity: 0.8;
  transition: transform ${animationTime} ${animationCurve}, opacity ${animationTime} ${animationCurve};

  .slick-center & {
    transform: none;
    opacity: 1;
  }
`

const FlavourLabel = styled(H3)`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  color: ${white};
  text-transform: uppercase;
  opacity: 0;
  font-weight: ${fontWeights.regular};
  transition: opacity ${animationTime} ${animationCurve}, transform ${animationTime} ${animationCurve};
  margin: 0 auto;

  .slick-center & {
    opacity: 1;
  }
`

export const Flavour = ({ slug, label }) => (
  <FlavourContainer>
    <FlavourFigure src={`${process.env.BASE_PATH}/images/products/epod/droplets/${slug}.png`} />
    <FlavourLabel>{label}</FlavourLabel>
  </FlavourContainer>
)

Flavour.propTypes = {
  slug: string.isRequired,
  label: string.isRequired
}

export default class FlavourSlider extends Component {
  constructor(props) {
    super(props)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
  }
  next() {
    this.slider.slickNext()
  }
  previous() {
    this.slider.slickPrev()
  }

  render() {
    const settings = {
      infinite: true,
      arrows: false,
      slidesToShow: 5,
      focusOnSelect: true,
      centerMode: true,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: breakpoints.small,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    }
    return (
      <Container>
        <Slider ref={c => (this.slider = c)} {...settings}>
          <Flavour slug="cool-peppermint" label="Cool Peppermint" />
          <Flavour slug="rich-tobacco" label="Rich Tobacco" />
          <Flavour slug="strawberry" label="Strawberry" />
          <Flavour slug="blood-orange" label="Blood Orange" />
          <Flavour slug="blueberry" label="Blueberry" />
          <Flavour slug="watermelon" label="Watermelon" />
          <Flavour slug="aromatic-tobacco" label="Aromatic Tobacco" />
          <Flavour slug="cucumber" label="Cucumber" />
          <Flavour slug="lychee" label="Lychee" />
          <Flavour slug="tobacco" label="Golden Tobacco" />
          <Flavour slug="mango" label="Mango" />
          <Flavour slug="mint" label="Polar Mint" />
          <Flavour slug="berry" label="Berry Blast" />
          <Flavour slug="vanilla" label="Vanilla" />
          <Flavour slug="smooth-mint" label="Smooth Mint" />
          <Flavour slug="passionfruit" label="Passionfruit" />
          <Flavour slug="peach" label="Peach" />
          <Flavour slug="lemon-berry" label="Lemon Berry" />
          <Flavour slug="smooth-tobacco" label="Smooth Tobacco" />
          <Flavour slug="clear" label="Clear" />
        </Slider>
      </Container>
    )
  }
}
